export enum SnackbarStatus {
  SUCCESS = 'success',
  FAIL = 'fail',
}
